import React, { useEffect, useState } from "react";
import { endpoints } from "../../../../constants/Endpoints";
import HttpClient, { Methods } from "../../../../services/HttpClient";
import ProgressIndicator from "../../../ProgressIndicator";

function PhotoGallery(props) {
  const [images, setImages] = useState(null);

  const getImages = async () => {
    if (!images) {
      var fetchedImages = [];

      for (var index in props.files) {
        const response = await HttpClient.doRequest(Methods.POST, endpoints.lead.getImage, {
          id: props.files[index].id,
          trustedFileNameForFileStorage:
            props.files[index].trustedFileNameForFileStorage,
        })

        const blob = await response.blob();
        var uri = URL.createObjectURL(blob);

        fetchedImages.push(uri);
      }

      setImages(fetchedImages);
    }
  };

  useEffect(() => {
    getImages();
  }, []);

  return images ? (
    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-start" }}>
      {images.map((uri) => (
        <img
          key={uri}
          src={uri}
          alt=""
          style={{ height: "auto", width: "auto", maxWidth: "200px", margin: "2px" }}
        />
      ))}
    </div>
  ) : (
    <ProgressIndicator />
  );
}

export default PhotoGallery;